var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isPop)?_c('div',{staticClass:"popAdvertisement"},[_c('div',{staticClass:"popAdvertisement-box"},[_c('img',{staticClass:"img",attrs:{"src":_vm.datas.pic},on:{"click":_vm.toLink}}),_vm._v(" "),_c('div',{staticClass:"close",on:{"click":_vm.closeLayer}},[_c('i',{staticClass:"iconshanchu1 iconfont"})])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-152cffc8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/polymerization/popAdvertisement.vue
// module id = null
// module chunks = 